import React from "react";
import "../css/PremiumBackground.css";

const PremiumBackground = () => {
  return (
    <div className="premium-waves">
      <svg className="wave wave1" viewBox="0 0 1000 700">
        <path
          className="wave-glow"
          d="M0 340 C180 210 310 470 500 320 S820 180 1000 320"
        />
        <path
          className="wave-line"
          d="M0 340 C180 210 310 470 500 320 S820 180 1000 320"
        />
        <path
          className="wave-shine"
          d="M0 340 C180 210 310 470 500 320 S820 180 1000 320"
        />
      </svg>

      <svg className="wave wave2" viewBox="0 0 1000 700">
        <path
          className="wave-glow"
          d="M0 260 C200 420 360 120 610 270 S860 420 1000 260"
        />
        <path
          className="wave-line"
          d="M0 260 C200 420 360 120 610 270 S860 420 1000 260"
        />
        <path
          className="wave-shine"
          d="M0 260 C200 420 360 120 610 270 S860 420 1000 260"
        />
      </svg>

      <svg className="wave wave3" viewBox="0 0 1000 700">
        <path
          className="wave-glow"
          d="M0 420 C150 300 340 520 560 390 S840 270 1000 430"
        />
        <path
          className="wave-line"
          d="M0 420 C150 300 340 520 560 390 S840 270 1000 430"
        />
        <path
          className="wave-shine"
          d="M0 420 C150 300 340 520 560 390 S840 270 1000 430"
        />
      </svg>
    </div>
  );
};

export default PremiumBackground;